(() => {
  const getBadge = () => document.getElementById('cart-count-bubble');

  const formatCount = (count) => {
    const numeric = Number(count) || 0;
    return numeric > 99 ? '99+' : String(numeric);
  };

  const updateBadge = (count) => {
    const badge = getBadge();
    if (!badge) return;

    const numeric = Math.max(0, Number(count) || 0);
    badge.textContent = formatCount(numeric);
    badge.dataset.cartCount = String(numeric);
    badge.hidden = numeric === 0;
    badge.setAttribute(
      'aria-label',
      numeric === 1 ? '1 producto en la cesta' : `${numeric} productos en la cesta`,
    );
  };

  const announce = (message) => {
    let liveRegion = document.getElementById('MinimaGlobalCartStatus');
    if (!liveRegion) {
      liveRegion = document.createElement('p');
      liveRegion.id = 'MinimaGlobalCartStatus';
      liveRegion.className = 'visually-hidden';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveRegion);
    }

    liveRegion.textContent = '';
    window.setTimeout(() => {
      liveRegion.textContent = message;
    }, 20);
  };

  window.MinimaCartUI = {
    updateBadge,
    announce,
  };

  document.addEventListener('minima:cart-updated', (event) => {
    const cart = event.detail?.cart;
    if (!cart) return;
    updateBadge(cart.item_count);
  });
})();
